import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useUserContext } from "../contexts/UserContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from "chart.js";

import { Line } from "react-chartjs-2";
import { API_URL } from '../config/api';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

export default function Accueil() {
  const { user } = useUserContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const adminId = user._id || user.id;
    if (!adminId) {
      toast.error("Admin non identifié");
      return;
    }

    const fetchDashboard = async () => {
      try {
        const res = await fetch(
          `${API_URL}/dashboard/${adminId}`
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Erreur dashboard");
        setDashboard(data);
      } catch (err) {
        console.error(err);
        toast.error("Erreur chargement dashboard");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [user]);

const [dashboard, setDashboard] = useState({
  lastOrders: [],
  topClients: [],
  topProducts: [],
  lowStockProducts: [],
  caByMonth: {}
});


// const monthStats = useMemo(() => {
//   const now = new Date();
//   const month = now.getMonth();
//   const year = now.getFullYear();

//   const commandesMois = dashboard.lastOrders.filter(cmd => {
//     const d = new Date(cmd.createdAt);
//     return (
//       cmd.status === "livrée" &&
//       d.getMonth() === month &&
//       d.getFullYear() === year
//     );
//   });

//   const commandesCount = commandesMois.length;

//   const chiffreAffaires = commandesMois.reduce(
//     (sum, c) => sum + (c.totalAmount || 0),
//     0
//   );

//   const marge = commandesMois.reduce((total, cmd) => {
//     if (!cmd.cart) return total;
//     return (
//       total +
//       cmd.cart.reduce(
//         (s, item) =>
//           s +
//           ((Number(item.price) || 0) -
//             (Number(item.prixAchat) || 0)) *
//             (Number(item.quantity) || 1),
//         0
//       )
//     );
//   }, 0);

//   const panierMoyen =
//     commandesCount > 0 ? chiffreAffaires / commandesCount : 0;

//   return {
//     commandesCount,
//     chiffreAffaires,
//     marge,
//     panierMoyen
//   };
// }, [dashboard.lastOrders]);

const currentMonthLabel = new Date().toLocaleDateString("fr-FR", {
  month: "long",
  year: "numeric"
});

const [commandes, setCommandes] = useState([]);
const [monthStats, setMonthStats] = useState({
  commandesCount: 0,
  chiffreAffaires: 0,
  marge: 0
});


useEffect(() => {
  const fetchCommandes = async () => {
    if (!user?._id) return;

    try {
      const res = await fetch(`${API_URL}/commandes?adminId=${user._id}`);
      const data = await res.json();

      // 🔹 Enrichir chaque commande avec prixAchat, productTitle et productPrice
      const commandesAvecPrixAchat = data.map(cmd => {
        const cart = cmd.cart.map(item => ({
          ...item,
          prixAchat: item.productId?.prixAchat || 0,
          productTitle: item.productId?.title || item.title,
          productPrice: item.productId?.price || item.price
        }));
        return { ...cmd, cart };
      });

      setCommandes(commandesAvecPrixAchat);

      // 🔹 KPI globaux
      // let totalCA = 0;
      // let totalMarge = 0;

      commandesAvecPrixAchat.forEach(cmd => {
        if (cmd.status !== "livrée") return; // seulement les commandes livrées

        cmd.cart.forEach(item => {
          const prixVente = Number(item.productPrice || 0);
          const prixAchat = Number(item.prixAchat || 0);
          const quantite = Number(item.quantity || 1);

          // totalCA += prixVente * quantite;
          // totalMarge += (prixVente - prixAchat) * quantite;
        });
      });

  

      // 🔹 KPI du mois en cours
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      const commandesMois = commandesAvecPrixAchat.filter(cmd => {
        const d = new Date(cmd.createdAt);
        return (
          cmd.status === "livrée" &&
          d.getMonth() === currentMonth &&
          d.getFullYear() === currentYear
        );
      });

      const caMois = commandesMois.reduce((sum, cmd) => {
        return sum + cmd.cart.reduce((s, item) => s + (Number(item.productPrice || 0) * (Number(item.quantity) || 1)), 0);
      }, 0);

      const margeMois = commandesMois.reduce((sum, cmd) => {
        return sum + cmd.cart.reduce((s, item) => s + ((Number(item.productPrice || 0) - Number(item.prixAchat || 0)) * (Number(item.quantity) || 1)), 0);
      }, 0);

      setMonthStats({
        commandesCount: commandesMois.length,
        chiffreAffaires: caMois,
        marge: margeMois
      });

    } catch (err) {
      console.error("Erreur fetchCommandes :", err);
    }
  };

  fetchCommandes();
}, [user]);

const totalCommandesLivrees = useMemo(() => {
  if (!commandes || commandes.length === 0) return 0;
  return commandes.filter(cmd => cmd.status === "livrée").length;
}, [commandes]);

const caGlobal = useMemo(() => {
  if (!commandes || commandes.length === 0) return 0;
  return commandes
    .filter(cmd => cmd.status === "livrée")
    .reduce((sum, cmd) => sum + (cmd.totalAmount || 0), 0);
}, [commandes]);

const margeGlobal = useMemo(() => {
  if (!commandes || commandes.length === 0) return 0;
  return commandes
    .filter(cmd => cmd.status === "livrée")
    .reduce((total, cmd) => {
      if (!cmd.cart) return total;
      return total + cmd.cart.reduce((s, item) => {
        const prixVente = Number(item.price || 0); // ⚠️ utiliser price et non productPrice
        const prixAchat = Number(item.prixAchat || 0);
        const quantite = Number(item.quantity || 1);
        return s + (prixVente - prixAchat) * quantite;
      }, 0);
    }, 0);
}, [commandes]);


const caByYear = useMemo(() => {
  const result = {};

  if (!commandes || commandes.length === 0) return result;

  // 🔹 date min (1ère commande)
  const dates = commandes.map(c => new Date(c.createdAt));
  const minDate = new Date(Math.min(...dates));
  const maxDate = new Date();

  const cursor = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

  // 🔹 initialisation des mois à 0
  while (cursor <= maxDate) {
    const year = cursor.getFullYear();
    const month = String(cursor.getMonth() + 1).padStart(2, "0");

    if (!result[year]) result[year] = [];
    result[year].push({ month, value: 0 });

    cursor.setMonth(cursor.getMonth() + 1);
  }

  // 🔹 injection du vrai CA (livré seulement)
  commandes
    .filter(cmd => cmd.status === "livrée")
    .forEach(cmd => {
      const d = new Date(cmd.createdAt);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");

      const totalCmd = cmd.cart.reduce(
        (s, i) => s + (Number(i.productPrice || i.price || 0) * (Number(i.quantity) || 1)),
        0
      );

      const entry = result[year]?.find(m => m.month === month);
      if (entry) entry.value += totalCmd;
    });

  return result;
}, [commandes]);

const years = Object.keys(caByYear).sort((a, b) => b - a); // N → N-1
const [selectedYearIndex, setSelectedYearIndex] = useState(0);
const selectedYear = years[selectedYearIndex];


  const caByMonthLabels = Object.keys(dashboard.caByMonth);
const caByMonthValues = Object.values(dashboard.caByMonth);

const caByMonthChartData = {
  labels: caByMonthLabels,
  datasets: [
    {
      label: "Chiffre d'affaires (FCFA)",
      data: caByMonthValues,
      tension: 0.4,
      fill: false
    }
  ]
};

const caByMonthChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    y: {
      ticks: {
        callback: value => value.toLocaleString() + " FCFA"
      }
    }
  }
};

// 🔹 State pour les dépenses
const [depenses, setDepenses] = useState([]);
const [totalDepenses, setTotalDepenses] = useState(0);
const [depensesMois, setDepensesMois] = useState(0);

useEffect(() => {
  const fetchDepenses = async () => {
    if (!user?._id) return;

    try {
      const res = await fetch(`${API_URL}/depense/achat?adminId=${user._id}`);
      const data = await res.json();
      setDepenses(data);

      // Calcul total global
      const totalGlobal = data.reduce((s, d) => s + (Number(d.montant) || 0), 0);
      setTotalDepenses(totalGlobal);

      // Calcul total du mois en cours
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      const totalMois = data
        .filter(d => {
          const date = new Date(d.createdAt);
          return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
        })
        .reduce((s, d) => s + (Number(d.montant) || 0), 0);

      setDepensesMois(totalMois);

    } catch (err) {
      console.error("Erreur fetchDepenses :", err);
    }
  };

  fetchDepenses();
}, [user]);




  if (loading) return <div className="loading">Chargement...</div>;
  if (!dashboard) return <p>Aucune donnée dashboard</p>;




  return (
    <>
      <Navbar />
      <ToastContainer position="top-right" />

      <div className="dashboard-wrapper">
        <h1 className="dashboard-title">📊 Tableau de bord</h1>

        <div className="kpi-grid">
  {/* CA GLOBAL */}
  <div className="kpi-card">
    <h4>💰 Chiffre d'affaires global</h4>
    <p className="kpi-value">
      {caGlobal.toLocaleString()} FCFA
    </p>
  </div>

    {/* COMMANDES MOIS */}
 <div className="kpi-card">
  <h4>📦 Commandes Total livrées</h4>
  <p className="kpi-value">
    {totalCommandesLivrees}
  </p>
</div>

    <div className="kpi-card">
    <h4>📈 Bénéfice</h4>
    <p className="kpi-value">
      {margeGlobal.toLocaleString()} FCFA
    </p>
  </div>


</div>

        {/* <div className="kpi-grid">
  <div className="kpi-card">
    <h4>📅 CA – {currentMonthLabel}</h4>
    <p className="kpi-value">
      {monthStats.chiffreAffaires.toLocaleString()} FCFA
    </p>
  </div>

  <div className="kpi-card">
    <h4>📦 Commandes livrées (mois)</h4>
    <p className="kpi-value">
      {monthStats.commandesCount}
    </p>
  </div>


  <div className="kpi-card">
    <h4>📈 Marge – {currentMonthLabel}</h4>
    <p className="kpi-value">
      {monthStats.marge.toLocaleString()} FCFA
    </p>
  </div>

  <div className="kpi-card">
    <h4>🛒 Panier moyen (mois)</h4>
    <p className="kpi-value">
      {monthStats.panierMoyen.toLocaleString()} FCFA
    </p>
  </div>
</div> */}

        {/* ================= KPI ================= */}
       {/* <div className="kpi-grid">
  <div className="kpi-card">
    <h4>CA du mois</h4>
    <p className="kpi-value">
      {monthStats.chiffreAffaires.toLocaleString()} FCFA
    </p>
  </div>

  <div className="kpi-card">
    <h4>Commandes livrées</h4>
    <p className="kpi-value">{monthStats.commandesCount}</p>
  </div>

  <div className="kpi-card">
    <h4>Marge du mois</h4>
    <p className="kpi-value">
      {monthStats.marge.toLocaleString()} FCFA
    </p>
  </div>

  <div className="kpi-card">
    <h4>Panier moyen</h4>
    <p className="kpi-value">
      {monthStats.panierMoyen.toLocaleString()} FCFA
    </p>
  </div>
</div> */}

        {/* ================= TABLEAUX ================= */}
        <div className="grid-2">
          {/* Dernières commandes */}
          <div className="card">
            <h3>🧾 Dernières commandes</h3>
            <table>
              <thead>
                <tr>
                   <th>Date</th>
                  <th>N°</th>
                  <th>Client</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {dashboard.lastOrders.map(cmd => (
                  <tr key={cmd._id}>
                    <td>
              {cmd.createdAt
                ? new Date(cmd.createdAt).toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                  })
                : "—"}
            </td>
                    <td>{cmd.numeroCommande}</td>
                    <td>{cmd.client?.name || "N/A"}</td>
                    <td>{cmd.totalAmount.toLocaleString()} FCFA</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Top clients */}
          <div className="card">
            <h3>👑 Meilleurs clients</h3>
                          {dashboard.topClients.length === 0 ? (
                <p className="empty">Aucun client enregistré</p>
              ) : (
            <ul className="list">
              {dashboard.topClients.map((c, i) => (
                <li key={i}>
                  <strong>{c.name} {c.surname}</strong>
                  <span>{c.totalOrders} commandes</span>
                </li>
              ))}
            </ul>
            )}
          </div>
        </div>

        <div className="grid-2">
          {/* Top produits */}
         <div className="card">
  <h3>🔥 Top articles vendus</h3>

              {dashboard.topProducts.length === 0 ? (
                <p className="empty">Aucune vente enregistrée</p>
              ) : (
                <ul className="list">
                  {dashboard.topProducts.map((p, i) => (
                    <li key={i}>
                      <strong>{p.title}</strong>
                      <span>
                        {p.totalQuantity} unités •{" "}
                        {p.totalRevenue.toLocaleString()} FCFA
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

          {/* Stock faible */}
          <div className="card">
            <h3>⚠️ Articles stock faible</h3>
            <ul className="list danger">
              {dashboard.lowStockProducts.map(p => (
                <li key={p._id}>
                  <strong>{p.title}</strong>
                  <span>Stock : {p.stock}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ================= CA PAR MOIS ================= */}
<div className="grid-2">
   <div className="card">
  <h3>📈 Chiffre d'affaires par mois</h3>

  {/* Pagination par année */}
  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
    <button
      disabled={selectedYearIndex >= years.length - 1}
      onClick={() => setSelectedYearIndex(i => i + 1)}
    >
      ◀ Année précédente
    </button>

    <strong>{selectedYear}</strong>

    <button
      disabled={selectedYearIndex === 0}
      onClick={() => setSelectedYearIndex(i => i - 1)}
    >
      Année suivante ▶
    </button>
  </div>

  <table>
    <thead>
      <tr>
        <th>Mois</th>
        <th>CA</th>
      </tr>
    </thead>
    <tbody>
      {(caByYear[selectedYear] || []).map(({ month, value }) => (
        <tr key={month}>
          <td>
            {new Date(`${selectedYear}-${month}-01`).toLocaleDateString("fr-FR", {
              month: "long"
            })}
          </td>
          <td>{value.toLocaleString()} FCFA</td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
<div className="card">
  <h3>💸 Dépenses</h3>

  {/* Total global */}
  <p style={{ fontWeight: "bold", marginBottom: 10 }}>
    Total global : {totalDepenses.toLocaleString()} FCFA
  </p>

  {/* Total du mois en cours */}
  <p style={{ fontWeight: "bold", marginBottom: 0 }}>
    Ce mois-ci : {depensesMois.toLocaleString()} FCFA
  </p>
</div>
</div>
      </div>

      <Footer />

      {/* ================= CSS INLINE ================= */}
      <style>{`
        .dashboard-wrapper {
          padding: 30px;
          background: #f5f7fb;
          min-height: 100vh;
        }

        .dashboard-title {
          font-size: 1.8rem;
          margin-bottom: 25px;
        }

        .kpi-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .kpi-card {
          background: white;
          padding: 20px;
          border-radius: 14px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        .kpi-card.danger {
          background: #fff1f0;
        }

        .kpi-card h4 {
          font-size: 0.95rem;
          color: #666;
        }

        .kpi-value {
          font-size: 1.6rem;
          font-weight: bold;
          margin-top: 8px;
        }

        .grid-2 {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 25px;
          margin-bottom: 30px;
        }

        .card {
          background: white;
          padding: 20px;
          border-radius: 14px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 12px;
        }

        th, td {
          padding: 10px;
          border-bottom: 1px solid #eee;
          text-align: left;
        }

        th {
          background: #fafafa;
          font-weight: 600;
        }

        .list {
          list-style: none;
          padding: 0;
          margin-top: 10px;
        }

        .list li {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px solid #eee;
        }

        .list.danger li span {
          color: #e53935;
          font-weight: 600;
        }

        .loading {
          padding: 100px;
          text-align: center;
          font-size: 1.2rem;
        }
          .empty {
  margin-top: 12px;
  padding: 14px;
  background: #fafafa;
  border-radius: 10px;
  text-align: center;
  color: #999;
  font-style: italic;
}
      `}</style>
    </>
  );
}